import { put, call, fork, takeMaybe } from 'redux-saga/effects'
import { updateTagService } from 'src/api/tag'
import { updateTagSuccess } from 'src/reducers/tag/action'
import { TAG_UPDATE } from 'src/reducers/tag/type'
import generalSaga from '../general'
import { operationSuccess, operationFail } from 'src/reducers/operation/action'

function* updateTagFlow(payload) {
  try {
    const { id, entity, callback } = payload
    yield call(updateTagService, id, entity)
    yield put(updateTagSuccess({ id, ...entity }))
    yield put(operationSuccess())
    if (callback) callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

export default function* updateTagWatcher() {
  while (true) {
    const action = yield takeMaybe(TAG_UPDATE)
    const { payload } = action

    yield fork(generalSaga, updateTagFlow, payload)
  }
}
